(function () {
    'use strict';

    /**
     * 通用会员促销引擎 — PDP 逻辑（泛化自 opendots2-be-promo.js / openrunpro2-lunar-white-promo.js）
     * 配置来源：window.__memberPromos（sections/member-promo.liquid，每个 block 一个活动）。
     * 多活动命中同一变体时按数组顺序先到先得；单一胜出活动同时驱动 ATC 与价格。
     *
     * 行为：
     * - ATC：enableAtc 关闭 = 命中变体隐藏加购按钮（含吸底栏克隆）。开启时会员 → memberLabel
     *   （留空 = 原文案）；非会员/未登录 → joinLabel + 拦截跳转 hubUrl + GA4。
     *   joinLabel 留空 = 纯会员价模式（不改文案、不拦截）。
     * - 价格：memberPrice 非空且会员时，替换 PDP 价格区为会员价/划线价/角标。
     * - 留邮：enableNotify 关闭 = 不显示。开启且 notifyLabel + klaviyoFormId 均非空且非会员时，
     *   加购按钮下方显示留邮按钮（主信息区 + 吸底栏同步），点击打开 Klaviyo onsite 弹窗表单（openForm）并上报 GA4；
     *   提交成功（klaviyoForms submit）后上报 subscribe（status=success）；售罄时让位主题自带 BIS。
     * - 未命中变体或活动到期：自动还原文案、价格与留邮按钮。
     */

    function getPromos() {
        return window.__memberPromos || [];
    }

    function isCampaignActive(campaign) {
        if (!campaign || campaign.active === false) {
            return false;
        }
        if (campaign.endsAt) {
            const end = Date.parse(String(campaign.endsAt).replace(' UTC', 'Z'));
            if (!Number.isNaN(end) && Date.now() >= end) {
                return false;
            }
        }
        return true;
    }

    function isLoggedIn() {
        return Boolean(window.customer && window.customer.id);
    }

    function isMember(memberTag) {
        const tag = memberTag || 'ShokzSquad';
        const fromTags = Boolean(
            window.customer && window.customer.tags && window.customer.tags.indexOf(tag) !== -1
        );
        const fromShokzMember = Boolean(
            window.ShokzMember &&
            typeof window.ShokzMember.isMember === 'function' &&
            window.ShokzMember.isMember()
        );
        return fromTags || fromShokzMember;
    }

    function campaignMatchesVariant(campaign, variantId) {
        if (!campaign || !campaign.variantIds || variantId === null || variantId === undefined) {
            return false;
        }
        return campaign.variantIds.map(String).indexOf(String(variantId)) !== -1;
    }

    function resolveCampaign(variantId) {
        const promos = getPromos();
        for (let i = 0; i < promos.length; i++) {
            if (isCampaignActive(promos[i]) && campaignMatchesVariant(promos[i], variantId)) {
                return promos[i];
            }
        }
        return null;
    }

    function getActiveVariantIdFromPdp() {
        const wrapper = document.querySelector('.product__info-wrapper');
        if (wrapper && wrapper.dataset.variantId) {
            return wrapper.dataset.variantId;
        }
        const input = document.querySelector('.product-form input[name="id"]');
        return input ? input.value : null;
    }

    /* ---------------------------------------------------------------- ATC 文案 */

    const ATC_HIDDEN_CLASS = 'member-promo-atc-hidden';

    function isAtcEnabled(campaign) {
        return Boolean(campaign && campaign.enableAtc !== false);
    }

    function getSubmitButtons() {
        // document 级作用域：连带吸底栏 updateAddCart() 克隆走的副本
        return document.querySelectorAll('.product-form__buttons .product-form__submit');
    }

    function hideAtcButtons() {
        injectStyles();
        getSubmitButtons().forEach(function (button) {
            button.classList.add(ATC_HIDDEN_CLASS);
        });
    }

    function showAtcButtons() {
        document.querySelectorAll('.' + ATC_HIDDEN_CLASS).forEach(function (button) {
            button.classList.remove(ATC_HIDDEN_CLASS);
        });
    }

    function shouldSkipSubmitButton(button) {
        if (!button) return true;
        if (button.disabled || button.getAttribute('data-disabled') === '1') return true;
        if (button.classList.contains('hidden')) return true;

        const span = button.querySelector('span');
        if (!span) return true;

        const text = span.textContent.trim();
        const reservedLabels = ['Discontinued'];
        if (window.variantStrings) {
            if (window.variantStrings.soldOut) reservedLabels.push(window.variantStrings.soldOut);
            if (window.variantStrings.unavailable) reservedLabels.push(window.variantStrings.unavailable);
        }
        return reservedLabels.indexOf(text) !== -1;
    }

    function updateSubmitButtonLabels() {
        const variantId = getActiveVariantIdFromPdp();
        const campaign = resolveCampaign(variantId);

        // ATC 开关关闭 → 命中变体隐藏加购按钮（文案一并还原）
        if (campaign && !isAtcEnabled(campaign)) {
            hideAtcButtons();
            restoreSubmitButtonLabels();
            return;
        }

        // 未命中 / 开关开启 → 确保按钮可见（处理从隐藏变体切回的情况）
        showAtcButtons();

        const buttons = getSubmitButtons();

        // 无命中活动，或活动未配置 joinLabel（纯会员价模式）→ 不动文案
        if (!campaign || !campaign.joinLabel) {
            restoreSubmitButtonLabels();
            return;
        }

        const member = isLoggedIn() && isMember(campaign.memberTag);

        buttons.forEach(function (button) {
            if (shouldSkipSubmitButton(button)) return;

            const span = button.querySelector('span');
            if (!span) return;

            if (!span.dataset.mpOriginalLabel) {
                span.dataset.mpOriginalLabel = span.textContent.trim();
            }

            const nextLabel = member
                ? campaign.memberLabel || span.dataset.mpOriginalLabel
                : campaign.joinLabel;
            if (span.textContent.trim() === nextLabel) return;

            span.textContent = nextLabel;
        });
    }

    function restoreSubmitButtonLabels() {
        const buttons = document.querySelectorAll('.product-form__buttons .product-form__submit');
        buttons.forEach(function (button) {
            const span = button.querySelector('span');
            if (!span || !span.dataset.mpOriginalLabel) return;

            if (shouldSkipSubmitButton(button)) {
                delete span.dataset.mpOriginalLabel;
                return;
            }

            span.textContent = span.dataset.mpOriginalLabel;
            delete span.dataset.mpOriginalLabel;
        });
    }

    /* ---------------------------------------------------------------- 会员价格 */

    function injectStyles() {
        if (document.getElementById('member-promo-styles')) return;

        const style = document.createElement('style');
        style.id = 'member-promo-styles';
        style.textContent = [
            '.member-promo-atc-hidden{display:none !important;}',
            '.member-promo-price{display:flex; align-items:center;}',
            '.member-promo-price-block{display:inline-flex;flex-direction:column;gap:2px;}',
            '.member-promo-price__badge{display:inline-block;align-self:flex-start;padding:2px 8px;border-radius:999px;background:#ff7a3d;color:#fff;font-size:12px;font-weight:600;line-height:1.4;letter-spacing:.02em;text-transform:uppercase;}',
            '.member-promo-price__member{color:#050505;font-family:"Shokz Sans Display",font-size:24px;font-weight:400;}',
            '.member-promo-price__compare{color:#BABABA;text-decoration:line-through;margin-left:8px;font-size:18px;}',
            '.product_template_new .product__info-wrapper .product-form__buttons .member-promo-notify-btn{display:flex;width:100%;align-items:center;justify-content:center;box-sizing:border-box;margin-top:12px;padding:12.6px 20px;border:1px solid #ffb688;border-radius:4px;background:transparent;font-family:var(--Shokz-Sans-Display,Shokz Sans Display),sans-serif;font-weight:500;font-size:16px;line-height:1.3;color:#ff7a3d;cursor:pointer;text-decoration:none;white-space:nowrap;}',
            '.product_template_new .product__info-wrapper .product-form__buttons .member-promo-notify-btn:hover,.product_template_new .product__info-wrapper .product-form__buttons .member-promo-notify-btn:focus-visible{color:#ff7a3d;border-color:#ffb688;opacity:.9;}',
            '.product_template_new .section-buy-now-banner-pc .product-form__buttons .member-promo-notify-btn{margin:6px 0 0;font-family:inherit;font-weight:400;cursor:pointer;}',
            '@media screen and (max-width:768px){.product_template_new .product__info-wrapper .product-form__buttons .member-promo-notify-btn{margin-top:10px;padding:14px 16px;}.product_template_new .section-buy-now-banner-pc .product-form__buttons .member-promo-notify-btn{margin-top:4px;}}'
        ].join('');
        document.head.appendChild(style);
    }

    function buildMemberPriceHtml(campaign) {
        const badge = campaign.badgeLabel || '';
        const compare = campaign.comparePrice
            ? '<span class="member-promo-price__compare">' + campaign.comparePrice + '</span>'
            : '';
        return (
            '<div class="member-promo-price-block main-price">' +
            (badge ? '<div class="member-promo-price__badge">' +
                badge +
                '</div>' : '') +
            '<div class="price price--large member-promo-price">' +
            '<span class="member-promo-price__member">' +
            campaign.memberPrice +
            '</span>' +
            compare +
            '</div></div>'
        );
    }

    function getPriceRoot() {
        const byId = document.querySelector('.product__info-wrapper [id^="price-"]');
        if (byId) return byId;
        const mainPrice = document.querySelector('.product__info-wrapper .main-price');
        return mainPrice && typeof mainPrice.closest === 'function'
            ? mainPrice.closest('[id^="price-"]')
            : null;
    }

    function applyMemberPrice(campaign) {
        if (!campaign || !campaign.memberPrice) return;

        const priceRoot = getPriceRoot();
        if (!priceRoot) return;
        if (priceRoot.querySelector('.member-promo-price-block')) return;

        const priceEl = priceRoot.querySelector('.main-price');
        if (!priceEl) return;

        injectStyles();
        priceRoot.dataset.mpOriginalPrice = priceEl.outerHTML;
        priceEl.outerHTML = buildMemberPriceHtml(campaign);
    }

    function restoreMemberPrice() {
        const priceRoot = getPriceRoot();
        if (!priceRoot) return;

        const blockEl = priceRoot.querySelector('.member-promo-price-block');
        if (!blockEl) return;

        if (priceRoot.dataset.mpOriginalPrice) {
            blockEl.outerHTML = priceRoot.dataset.mpOriginalPrice;
            delete priceRoot.dataset.mpOriginalPrice;
        }
    }

    function updateMemberPrice() {
        const variantId = getActiveVariantIdFromPdp();
        const campaign = resolveCampaign(variantId);
        const member = campaign ? isLoggedIn() && isMember(campaign.memberTag) : false;

        if (campaign && campaign.memberPrice && member) {
            applyMemberPrice(campaign);
        } else {
            restoreMemberPrice();
        }
    }

    /* ---------------------------------------------------------------- 留邮按钮 */

    const NOTIFY_BTN_CLASS = 'member-promo-notify-btn';
    // WeakSet 记录已挂监听的按钮节点：吸底栏 updateAddCart() 用 jQuery .clone() 克隆主区表单，
    // 事件监听不会随属性一起复制，克隆副本是"死按钮"，必须重新挂载
    const notifyButtonsBound = typeof WeakSet === 'function' ? new WeakSet() : null;

    function getNotifyButtonGroups() {
        // 主信息区 + 吸底栏各持有一份 .product-form__buttons（吸底栏由 updateAddCart() 克隆替换），逐组同步
        return document.querySelectorAll(
            '.product_template_new .product__info-wrapper .product-form__buttons, .product_template_new .section-buy-now-banner-pc .product-form__buttons'
        );
    }

    function removeNotifyButtons() {
        // document 级作用域：连带清理吸底栏 updateAddCart() 克隆走的副本
        document.querySelectorAll('.' + NOTIFY_BTN_CLASS).forEach(function (btn) {
            btn.remove();
        });
    }

    function shouldShowNotifyButton(campaign) {
        if (!campaign || campaign.enableNotify === false) return false;
        if (!campaign.notifyLabel || !campaign.klaviyoFormId) return false;
        return !(isLoggedIn() && isMember(campaign.memberTag));
    }

    function trackNotifyClick(campaign) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event_parameters: null });
        window.dataLayer.push({
            event: 'ga4Event',
            event_name: 'select_content',
            event_parameters: {
                content_type: campaign.ga4ContentType || 'PDP_Purchase_Bottom',
                content_name: campaign.ga4ContentName || 'member_promo',
                button_name: campaign.ga4NotifyButtonName || 'Notify_Me'
            }
        });
    }

    /* notify 打开的表单 ID → 活动：klaviyoForms submit 成功时据此匹配上报 subscribe */
    let notifyFormCampaign = null;

    function openKlaviyoNotifyForm(campaign) {
        const formId = campaign && campaign.klaviyoFormId ? String(campaign.klaviyoFormId).trim() : '';
        if (!formId) return;

        notifyFormCampaign = campaign;

        window._klOnsite = window._klOnsite || [];
        if (typeof window._klOnsite.push !== 'function') {
            if (window.console && typeof window.console.warn === 'function') {
                window.console.warn('[member-promo] window._klOnsite is not a queue; Klaviyo onsite unavailable.');
            }
            return;
        }
        window._klOnsite.push(['openForm', formId]);
    }

    /* 留邮提交成功埋点：subscribe（status=success），参数取活动配置 */
    function trackNotifySubscribe(formId) {
        const campaign = notifyFormCampaign;
        if (!campaign) return;

        const expectedFormId = campaign.klaviyoFormId ? String(campaign.klaviyoFormId).trim() : '';
        if (!expectedFormId || String(formId || '') !== expectedFormId) return;
        notifyFormCampaign = null;

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event_parameters: null });
        window.dataLayer.push({
            event: 'ga4Event',
            event_name: 'subscribe',
            event_parameters: {
                module: campaign.ga4NotifyModule || 'PDP_Purchase_Bottom',
                status: 'success',
                button_name: campaign.ga4SubscribeButtonName || campaign.ga4NotifyButtonName || 'Notify_Me'
            }
        });
    }

    function initNotifySubscribeTracking() {
        window.addEventListener('klaviyoForms', function (event) {
            try {
                const detail = event.detail;
                if (!detail || detail.type !== 'submit') return;
                trackNotifySubscribe(detail.formId ?? detail.formID);
            } catch (error) {
                if (window.console && typeof window.console.warn === 'function') {
                    window.console.warn('[member-promo] klaviyoForms handler failed', error);
                }
            }
        });
    }

    function updateNotifyButton() {
        const variantId = getActiveVariantIdFromPdp();
        const campaign = resolveCampaign(variantId);

        if (!shouldShowNotifyButton(campaign)) {
            removeNotifyButtons();
            return;
        }

        injectStyles();

        getNotifyButtonGroups().forEach(function (buttonsWrap) {
            const existing = buttonsWrap.querySelector('.' + NOTIFY_BTN_CLASS);

            // 售罄让位：主题自带 Klaviyo BIS（Notify Me）可见时不叠第二个留邮按钮
            if (buttonsWrap.querySelector('#klaviyo-product-btn:not(.hidden)')) {
                if (existing) existing.remove();
                return;
            }

            let btn = existing;
            if (!btn) {
                btn = document.createElement('button');
                btn.type = 'button'; // 父级是商品 form，必须显式 type=button
                btn.className = NOTIFY_BTN_CLASS;
                buttonsWrap.appendChild(btn);
            }

            // 新建或来自 jQuery 克隆的副本都可能缺监听，逐节点确认（data-* 属性会随克隆携带，不能用标记位）
            if (!notifyButtonsBound || !notifyButtonsBound.has(btn)) {
                if (notifyButtonsBound) notifyButtonsBound.add(btn);
                btn.addEventListener('click', function (event) {
                    event.preventDefault();
                    event.stopPropagation();

                    // 点击时重新解析：按钮元素跨变体复用，闭包捕获旧活动会在多活动场景开错表单
                    const current = resolveCampaign(getActiveVariantIdFromPdp());
                    if (!current) return;

                    trackNotifyClick(current);
                    openKlaviyoNotifyForm(current);
                });
            }

            if (btn.textContent !== campaign.notifyLabel) btn.textContent = campaign.notifyLabel;
            btn.setAttribute('aria-label', campaign.notifyLabel);
            btn.dataset.mpCampaignId = campaign.id;
        });
    }

    /* ------------------------------------------------------- 拦截 + GA4 上报 */

    function shouldRedirectJoinSubmit() {
        const variantId = getActiveVariantIdFromPdp();
        const campaign = resolveCampaign(variantId);
        if (!campaign || !isAtcEnabled(campaign) || !campaign.joinLabel) return false;
        return !(isLoggedIn() && isMember(campaign.memberTag));
    }

    function isJoinSubmitButton(button, campaign) {
        if (!button || !campaign || !isAtcEnabled(campaign) || !campaign.joinLabel) return false;
        if (shouldSkipSubmitButton(button)) return false;
        const span = button.querySelector('span');
        return Boolean(span && span.textContent.trim() === campaign.joinLabel);
    }

    function trackJoinClick(campaign) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event_parameters: null });
        window.dataLayer.push({
            event: 'ga4Event',
            event_name: 'select_content',
            event_parameters: {
                content_type: campaign.ga4ContentType || 'PDP_Purchase_Bottom',
                content_name: campaign.ga4ContentName || 'member_promo',
                button_name: campaign.ga4ButtonName || 'Join_Now'
            }
        });
    }

    /* 会员点击加购按钮的埋点：add_to_cart，参数用会员专属配置；
       打 __mpMemberAtc 标记让 dataLayer.liquid 的通用 add_to_cart 跳过，避免重复上报 */
    function getMemberVariantInfo(variantId) {
        const list = window.__memberPromoVariants || [];
        return (
            list.find(function (v) {
                return v && String(v.id) === String(variantId);
            }) || null
        );
    }

    function trackMemberAtcClick(event) {
        const variantId = getActiveVariantIdFromPdp();
        const campaign = resolveCampaign(variantId);
        if (!campaign || !isAtcEnabled(campaign)) return;

        const button =
            event.target && event.target.closest
                ? event.target.closest('.product-form__buttons .product-form__submit')
                : null;
        if (!button || shouldSkipSubmitButton(button)) return;

        if (!(isLoggedIn() && isMember(campaign.memberTag))) return;

        event.__mpMemberAtc = true;

        const variant = getMemberVariantInfo(variantId);
        const sku = variant ? variant.sku : '';
        // getProductInfo 由 dataLayer.liquid 提供（sku -> title/type/name/size/color）
        const rawInfo = sku && typeof getProductInfo === 'function' ? getProductInfo(sku) : null;
        const info = rawInfo && typeof rawInfo === 'object' ? rawInfo : null;
        let category2 = variant ? variant.option2 : '';
        if (!category2 && info) category2 = info.size;

        const itemListId =
            campaign.ga4MemberItemListId ||
            (window.__memberPromoProductHandle ? window.__memberPromoProductHandle + ' bottom' : 'bottom');
        const itemListName = campaign.ga4MemberItemListName || itemListId;
        const price = variant ? variant.price : '';

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event_parameters: null });
        window.dataLayer.push({
            event: 'ga4Event',
            event_name: 'add_to_cart',
            event_parameters: {
                currency: 'USD',
                value: price,
                module: campaign.ga4MemberModule || 'Purchase',
                button_name: campaign.ga4MemberButtonName || campaign.ga4ButtonName || 'Add_To_Cart',
                item_list_id: itemListId,
                item_list_name: itemListName,
                items: [
                    {
                        item_list_id: itemListId,
                        item_list_name: itemListName,
                        item_id: sku,
                        item_name: info ? info.title : '',
                        discount: 0,
                        item_category: info ? info.name : '',
                        item_category2: category2,
                        item_category3: info ? info.color : '',
                        item_variant: info ? info.type : '',
                        item_brand: 'SHOKZ',
                        price: price,
                        quantity: 1,
                        currency: 'USD'
                    }
                ]
            }
        });
    }

    function stopAndRedirect(event, campaign) {
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') {
            event.stopImmediatePropagation();
        }

        trackJoinClick(campaign);
        window.location.assign(campaign.hubUrl || '/pages/shokzsquad-signup');
    }

    function redirectJoinSubmit(event) {
        if (!shouldRedirectJoinSubmit()) return false;

        const campaign = resolveCampaign(getActiveVariantIdFromPdp());
        const button =
            event.target && event.target.closest
                ? event.target.closest('.product-form__buttons .product-form__submit')
                : null;
        if (!isJoinSubmitButton(button, campaign)) return false;

        stopAndRedirect(event, campaign);
        return true;
    }

    function initJoinSubmitRedirect() {
        const root = document.querySelector('.product_template_new');
        if (!root) return;

        root.addEventListener(
            'click',
            function (event) {
                // 命中拦截（非会员/未登录）时不再重复上报会员埋点
                if (redirectJoinSubmit(event)) return;
                trackMemberAtcClick(event);
            },
            true
        );

        root.addEventListener(
            'submit',
            function (event) {
                if (!shouldRedirectJoinSubmit()) return;

                const campaign = resolveCampaign(getActiveVariantIdFromPdp());

                const form = event.target;
                if (!form || form.tagName !== 'FORM') return;

                const button = form.querySelector('.product-form__buttons .product-form__submit');
                if (!isJoinSubmitButton(button, campaign)) return;

                stopAndRedirect(event, campaign);
            },
            true
        );
    }

    /* ------------------------------------------------------------- 再驱动机制 */

    function observeSubmitButtonDom() {
        const banner = document.querySelector('.product_template_new .section-buy-now-banner-pc');
        if (!banner || typeof MutationObserver === 'undefined') return;

        const observer = new MutationObserver(function (mutations) {
            const hasNewSubmitButton = mutations.some(function (mutation) {
                return Array.from(mutation.addedNodes).some(function (node) {
                    if (node.nodeType !== 1) return false;
                    if (typeof node.matches === 'function') {
                        if (node.matches('.product-form__submit, .product-form__buttons, product-form')) {
                            return true;
                        }
                    }
                    return typeof node.querySelector === 'function' && node.querySelector('.product-form__submit');
                });
            });
            if (hasNewSubmitButton) {
                scheduleApply();
            }
        });

        observer.observe(banner, { childList: true, subtree: true });
    }

    function initExpiryWatcher() {
        let nearest = Infinity;
        getPromos().forEach(function (campaign) {
            if (!campaign.endsAt) return;
            const end = Date.parse(String(campaign.endsAt).replace(' UTC', 'Z'));
            if (!Number.isNaN(end) && end < nearest) {
                nearest = end;
            }
        });
        if (nearest === Infinity) return;

        const delay = Math.min(Math.max(nearest - Date.now() + 1000, 0), 2147483647);
        setTimeout(applyAll, delay);
    }

    function applyAll() {
        updateSubmitButtonLabels();
        updateMemberPrice();
        updateNotifyButton();
    }

    let applyTimer = null;

    function scheduleApply() {
        if (applyTimer) clearTimeout(applyTimer);
        applyTimer = setTimeout(applyAll, 0);
    }

    /* ----------------------------------------------------------------- 启动 */

    document.addEventListener('DOMContentLoaded', function () {
        if (window.__memberPromoBootstrapped) return;
        window.__memberPromoBootstrapped = true;

        const promos = getPromos();
        if (!promos.length) return;
        if (!promos.some(isCampaignActive)) return;

        applyAll();
        initJoinSubmitRedirect();
        initNotifySubscribeTracking();
        observeSubmitButtonDom();
        initExpiryWatcher();

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            subscribe(PUB_SUB_EVENTS.variantChange, scheduleApply);
        }
    });
})();
